export default "__VITE_ASSET__BLa0Rlih__"